import { render, staticRenderFns } from "./VideoDescTop.vue?vue&type=template&id=6a87fd44&scoped=true"
import script from "./VideoDescTop.vue?vue&type=script&lang=js"
export * from "./VideoDescTop.vue?vue&type=script&lang=js"
import style0 from "./VideoDescTop.vue?vue&type=style&index=0&id=6a87fd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a87fd44",
  null
  
)

export default component.exports